import { AuthenticatedUser } from "@services/user/types";
import { hasNoPermission } from "./hasNoPermission";
import { canViewWorkflows, hasLicense, isSuperAdmin } from "@common/utils/user";

const globalConfigPaths = /^\/configuration\/.*/;
const usersPath = /^\/configuration\/users.*/;
const workflowPath = /^\/configuration\/workflows\/.*/;
const rolesAndCapabilitiesPath = /^\/configuration\/rolesAndCapabilities.*/;
const auditTrailsPath = /^\/configuration\/audits.*/;

export const hasNoPermissionToViewGlobalConfigPath = (
  path: Location["pathname"],
  user: AuthenticatedUser
) => {
  if (!globalConfigPaths.test(path)) {
    return false;
  }

  // edge cases, globalConfiguration permission is not necessary
  if (usersPath.test(path)) {
    return hasNoPermission(user, "users");
  }

  if (workflowPath.test(path)) {
    return !canViewWorkflows(user) || !hasLicense(user.account, "workflows");
  }

  // common condition for /configuration/* paths
  if (!isSuperAdmin(user) || hasNoPermission(user, "globalConfiguration")) {
    return true;
  }

  if (rolesAndCapabilitiesPath.test(path)) {
    return hasNoPermission(user, "rolesCapabilities");
  }

  if (auditTrailsPath.test(path)) {
    return !hasLicense(user.account, "auditTrails");
  }

  return false;
};
